import React from 'react';
import ContactImage from '../../Components/Assets/email.png';
import "../../styles/contact.css";
const ContactUs = () => {
    return(
        <div className="contact">
            <div className="container container-contact">
                <div className="contact-image col-md-6 d-flex">
                    <img draggable="false" src={ContactImage} alt="Contact"/>
                </div>
                <div className="form-contact">
                
                <form action="mailto:teamistesrmncr@gmail.com" method="post" enctype="text/plain">
                <span className="contact-heading">
                Get In Touch !
                </span>    
                <div className="form-content">
                    <h3 className="contact-paragraph"><i class="fas fa-user"></i> Name</h3>
                    <input className="input" placeholder="" type="text" name="name" required/>
                    <h3 className="contact-paragraph"><i class="fas fa-envelope"></i> Email ID</h3>
                    <input className="input" placeholder="" type="email" name="email" required/>
                    <h3 className="contact-paragraph"><i class="fas fa-comments"></i> Message</h3>
                    <textarea rows="5" placeholder="" type="text" required></textarea>
                    <button id="contact-send">Send !</button>
                    </div>
                </form> 
                </div>
            </div>
        </div>
    )
}

export default ContactUs;